import React from "react";
import {Card, Col, Row} from "react-bootstrap";
import HelpTooltip from "../../HelpTooltip.jsx";
import {formatQuantity} from "../../Statistics/format.js";

/**
 * Kennzahlen-Kacheln der Containerkunden-Übersicht (Meeting 22.09.2026
 * Punkt 4, docs/tasks/2026-09-18-cosmos-bereich/UMSETZUNG-NACH-MEETING.md
 * Punkt 6) - Summe über alle Kunden im gewählten Zeitraum. Verschwindet
 * ganz, wenn kein Kunde im Zeitraum bestellt hat (Hausvorgabe: leere
 * Bausteine nie anzeigen).
 */
export default function ContainerkundenKacheln({kunden}) {
    const kundenMitBestellung = (kunden || []).filter((k) => k.summe_menge > 0);
    if (kundenMitBestellung.length === 0) {
        return null;
    }

    const summeMenge = kundenMitBestellung.reduce((summe, k) => summe + Number(k.summe_menge || 0), 0);
    const summeBelege = kundenMitBestellung.reduce((summe, k) => summe + Number(k.summe_belege || 0), 0);
    const farbtoeneGesamt = new Set(
        kundenMitBestellung.flatMap((k) => (k.farbtoene || []).map((f) => f.artikel_nummer))
    ).size;

    return (
        <Row xs={1} sm={3} className="g-3 mb-3">
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Bestellte Menge</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Summe aller Buchungen der Containerkunden im gewählten Zeitraum, über alle Farbtöne.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{formatQuantity(summeMenge)} Stk.</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Kunden mit Bestellung</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Anzahl der gepflegten Containerkunden, die im gewählten Zeitraum mindestens eine
                                Buchung haben.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{kundenMitBestellung.length}</div>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="h-100 shadow-sm">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between">
                            <span className="text-muted small text-uppercase">Betroffene Farbtöne</span>
                            <HelpTooltip placement="left" size={0.75}>
                                Anzahl unterschiedlicher Artikel, die von Containerkunden im gewählten Zeitraum
                                bestellt wurden.
                            </HelpTooltip>
                        </div>
                        <div className="fs-3 fw-semibold lh-sm mt-1">{formatQuantity(farbtoeneGesamt)}</div>
                        <div className="small text-muted mt-1">{formatQuantity(summeBelege)} Belege</div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}
